import { Button } from 'uiKit/atoms/Button/Button';
import { Box } from 'uiKit/atoms/Box/Box';
import { Paragraph } from 'uiKit/atoms/Typography/components/Paragraph';
import { observer } from 'mobx-react';
import { ModalsList } from '../../constants';
import { useStores } from 'stores';
import styles from './CancelationModal.module.scss';
import { Typography } from 'uiKit/atoms/Typography/Typography';

const CancelationModal = () => {
  const {
    modalStore: { hideModal, modalConfirm },
  } = useStores();

  const handleConfirm = () => {
    modalConfirm();
    hideModal();
  };

  return (
    <Box className={styles.bns3_cancelation_modal_container}>
      <Typography variant="h6" className={styles.bns3_cancelation_modal_title}>
        Are you sure?
      </Typography>
      <Paragraph className={styles.bns3_cancelation_modal_subtitle}>{ModalsList.CancelationModal.text}</Paragraph>
      <Box className={styles.bns3_cancelation_modal_buttons_container}>
        <Button onClick={handleConfirm} className={styles.bns3_confirmation_button}>
          Yes, I am sure
        </Button>
        <Button onClick={hideModal} className={styles.bns3_non_confirmation_button}>
          No, I changed my mind
        </Button>
      </Box>
    </Box>
  );
};

export default observer(CancelationModal);
